/* eslint-disable no-use-before-define */

import React, { Component } from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'

class MultiselectCP extends Component {
  constructor(props) {
    super(props)
    /*
    this.state = {
      value: this.props.value || []
    }
    */
  }

  // componentDidMount() {}

  render() {
    const icon = <div className='bcioInputCircle'></div>;
    const checkedIcon = <div className='bcioInputCircle'>
      <div className='bcioCheckmark'></div>
    </div>;

    var isEditable = true // default to true
    if ('isEditable' in this.props) isEditable = this.props.isEditable
    isEditable = isEditable && this.props.meta.displayEditable
    return (
      <Autocomplete
        {...this.props.meta.markupAttributes}
        className="muiOverride"
        name={this.props.objPath}
        value={this.props.value}
        onChange={((event, value) => this._onChange(event, value))} 
        disabled={!isEditable} 
        multiple
        id={this.props.objPath}
        options={this.props.meta.displayTypeProps.enums}
        disableCloseOnSelect
        getOptionLabel={(option) => option.label}
        renderOption={(option, { selected }) => (
          <React.Fragment>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.label}
          </React.Fragment>
        )}
        style={{ maxWidth: '56rem' }}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" placeholder={this.props.meta.displayTypeProps.placeholder} />
        )}
      />
    )
  }

  _onChange(event, value) {
    //this.setState({value: value})
    this.props.onChange(event, value, this.props.objPath)
  } 
}

export default MultiselectCP
